import { render, staticRenderFns } from "./AddMachine.vue?vue&type=template&id=37f28d89&scoped=true"
import script from "./AddMachine.vue?vue&type=script&lang=js"
export * from "./AddMachine.vue?vue&type=script&lang=js"
import style0 from "./AddMachine.vue?vue&type=style&index=0&id=37f28d89&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f28d89",
  null
  
)

export default component.exports